export enum UserRoleEnum {
    GENERAL_PUBLIC = 1,
    DCSYW_ADMIN,
    SSQ_ADMIN,
    DCDSS_ADMIN,
    SSQ_CSA,
    DCDSS_Outreach
}
